import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar/navbar.component';
import { SharedModule } from '@shared/shared.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LoginComponent, AuthService, RecoverPasswordComponent } from './auth';

@NgModule({
    declarations: [
        LoginComponent,
        NavbarComponent,
        RecoverPasswordComponent,
        SidebarComponent,
    ],
    imports: [SharedModule],
    providers: [AuthService],
    exports: [
        NavbarComponent,
        SidebarComponent
    ]
})
export class CoreModule { }
